import ConfigurationIcons from '@/icons/ConfigurationIcons'
import { ServiceConfigOption } from '@/modules/Contract/types'
import { formatCurrency, formatNumberUsage } from '@/utils/function'
import { useTranslation } from 'react-i18next'
import { Typogaphy, Chip } from 'vnetwork-ui'

interface IViewConfigProps {
    service_configoptions: ServiceConfigOption[]
    isPOC?: boolean
}

const ViewConfig: React.FC<IViewConfigProps> = ({
    service_configoptions,
    isPOC = false,
}) => {
    const { t } = useTranslation()

    if (!service_configoptions || service_configoptions.length === 0) {
        return (
            <div className="text-center py-4 text-gray-500">
                <Typogaphy size="small" className="text-gray-500">
                    {t('contract.no_configurations')}
                </Typogaphy>
            </div>
        )
    }

    return (
        <div className="space-y-1.5">
            {service_configoptions?.map((config, configIndex) => (
                <div
                    key={config?.name || configIndex}
                    className="flex items-center justify-between px-3 py-2 bg-slate-50/50 hover:bg-slate-100/50 rounded border border-slate-200/60 transition-colors"
                >
                    <div className="flex items-center gap-2.5 min-w-0 flex-1">
                        <div className="w-6 h-6 bg-slate-100 rounded flex items-center justify-center flex-shrink-0">
                            <ConfigurationIcons className="w-3.5 h-3.5 text-slate-600" />
                        </div>
                        <div className="min-w-0 flex-1">
                            <div className="flex items-center gap-2 flex-wrap">
                                <Typogaphy className="font-medium text-slate-800 text-sm truncate">
                                    {t(config?.name) || config?.name}
                                </Typogaphy>
                                <div className="flex items-center gap-1.5 text-xs text-slate-600">
                                    <Typogaphy>
                                        {formatNumberUsage(
                                            config?.commitment_value || 0
                                        )}
                                        <span className="text-slate-500">
                                            {t(config?.unit)}
                                        </span>
                                    </Typogaphy>

                                    {config?.commitment_price_per_unit &&
                                        !isPOC && (
                                            <>
                                                <span className="text-slate-400">
                                                    •
                                                </span>
                                                <span className="text-emerald-600">
                                                    {config?.commitment_price_per_unit
                                                        ? '---'
                                                        : formatCurrency(
                                                              config?.commitment_price_per_unit
                                                          )}
                                                </span>
                                            </>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex items-center gap-1.5 flex-shrink-0">
                        {!!config?.statementable && !isPOC && (
                            <Chip
                                label={t('contract.monthly_statement')}
                                size="small"
                                color="primary"
                                variant="contained"
                                className="text-xs"
                            />
                        )}
                        {config?.prices &&
                            config?.prices?.length > 0 &&
                            !isPOC && (
                                <Chip
                                    label={
                                        config?.prices?.length === 1
                                            ? t('contract.single_price')
                                            : `${config?.prices?.length} ${t('contract.range_prices.tiers', { count: config?.prices?.length })}`
                                    }
                                    size="small"
                                    color="success"
                                    variant="contained"
                                    className="text-xs"
                                />
                            )}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default ViewConfig
